import type { IconProps } from '../types/IconProps.ts';
export const SquareChevronUp: IconProps = {
    name: 'SquareChevronUp',
    children: [
        `<path d="m8 14 3.65-3.65c.2-.2.5-.2.7 0L16 14" />`,
        `<rect width="18" height="18" x="3" y="3" rx="1" />`,
    ]
};